/* eslint-disable prettier/prettier */ 'use client';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HotelBrand } from '@whitbread-eos/api';
import { useElementDimensions } from '@whitbread-eos/utils';
import { getLocationResults, formatIBAssetsUrl, useTranslation } from '@whitbread-eos/utils/server';
import debounce from 'lodash/debounce';
import Image from 'next/image';
import React, { useEffect, useState, useRef } from 'react';
const MIN_LENGTH_SEARCH_TERM = 3;
const LocationResults = ({ location = '', setLocation, labels, isInputBlured, selectedLocation, setSelectedLocation, onResultsFound, mobile, globalLabels, onOpenChange })=>{
    var _results_places, _results_hotels, _results_places1, _results_hotels1;
    const { t } = useTranslation();
    const { height: headerHeight } = useElementDimensions('header');
    const [isOpen, setIsOpen] = useState(false);
    const [results, setResults] = useState({
        hotels: [],
        places: []
    });
    const [hasClickedResult, setHasClickedResult] = useState(false);
    const handleResultClick = (value)=>{
        setHasClickedResult(true);
        setLocation(value === null || value === void 0 ? void 0 : value.suggestion);
        setSelectedLocation(value);
    };
    const getHotelIcon = (brand)=>{
        var _globalLabels_brand;
        if (brand === HotelBrand.HUB) {
            var _globalLabels_brand1;
            return formatIBAssetsUrl(globalLabels === null || globalLabels === void 0 ? void 0 : (_globalLabels_brand1 = globalLabels.brand) === null || _globalLabels_brand1 === void 0 ? void 0 : _globalLabels_brand1.hubLogo);
        } else if (brand === HotelBrand.ZIP) {
            var _globalLabels_brand2;
            return formatIBAssetsUrl(globalLabels === null || globalLabels === void 0 ? void 0 : (_globalLabels_brand2 = globalLabels.brand) === null || _globalLabels_brand2 === void 0 ? void 0 : _globalLabels_brand2.zipLogo);
        }
        return formatIBAssetsUrl(globalLabels === null || globalLabels === void 0 ? void 0 : (_globalLabels_brand = globalLabels.brand) === null || _globalLabels_brand === void 0 ? void 0 : _globalLabels_brand.piLogo);
    };
    const getResults = function() {
        var _ref = _async_to_generator(function*(searchTerm) {
            var _newResults_properties, _newResults_places;
            const newResults = yield getLocationResults(searchTerm);
            if ((newResults === null || newResults === void 0 ? void 0 : (_newResults_properties = newResults.properties) === null || _newResults_properties === void 0 ? void 0 : _newResults_properties.length) || (newResults === null || newResults === void 0 ? void 0 : (_newResults_places = newResults.places) === null || _newResults_places === void 0 ? void 0 : _newResults_places.length)) {
                const allLocationResults = [
                    ...newResults.places,
                    ...newResults.properties
                ];
                const matchLocation = allLocationResults.find((item)=>item.suggestion === searchTerm);
                setSelectedLocation(matchLocation !== null && matchLocation !== void 0 ? matchLocation : allLocationResults[0]);
                setIsOpen(true);
                setResults({
                    hotels: newResults === null || newResults === void 0 ? void 0 : newResults.properties,
                    places: newResults === null || newResults === void 0 ? void 0 : newResults.places
                });
                onResultsFound(true);
            } else {
                onResultsFound(false);
                setIsOpen(false);
            }
        });
        return function getResults(searchTerm) {
            return _ref.apply(this, arguments);
        };
    }();
    const debouncedSearch = useRef(debounce(getResults, 300)).current;
    useEffect(()=>{
        if (location.trim() === (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.suggestion)) {
            return;
        }
        if (location && location.trim().length >= MIN_LENGTH_SEARCH_TERM && !hasClickedResult) {
            debouncedSearch(location);
        } else {
            setIsOpen(false);
            setSelectedLocation({});
            setHasClickedResult(false);
        }
    }, [
        location
    ]);
    useEffect(()=>{
        var _results_places, _results_hotels;
        onOpenChange(isOpen && !isInputBlured && (!!(results === null || results === void 0 ? void 0 : (_results_places = results.places) === null || _results_places === void 0 ? void 0 : _results_places.length) || !!(results === null || results === void 0 ? void 0 : (_results_hotels = results.hotels) === null || _results_hotels === void 0 ? void 0 : _results_hotels.length)));
    }, [
        isOpen,
        isInputBlured,
        results === null || results === void 0 ? void 0 : (_results_places = results.places) === null || _results_places === void 0 ? void 0 : _results_places.length,
        results === null || results === void 0 ? void 0 : (_results_hotels = results.hotels) === null || _results_hotels === void 0 ? void 0 : _results_hotels.length
    ]);
    const displayPlaces = ()=>{
        return /*#__PURE__*/ _jsx("div", {
            className: resultsColStyle,
            "data-testid": "IB-Places-List",
            children: results === null || results === void 0 ? void 0 : results.places.map((place)=>{
                return /*#__PURE__*/ _jsx("div", {
                    onMouseDown: ()=>handleResultClick(place),
                    className: `${resultRowStyle} ${placeRowStyle}`,
                    children: /*#__PURE__*/ _jsx("span", {
                        className: resultTextStyle,
                        children: place === null || place === void 0 ? void 0 : place.suggestion
                    })
                }, place === null || place === void 0 ? void 0 : place.suggestion);
            })
        });
    };
    const displayHotels = ()=>{
        return /*#__PURE__*/ _jsxs("div", {
            className: resultsColStyle,
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: hotelsSeparatorStyle,
                    children: t(labels === null || labels === void 0 ? void 0 : labels.hotelsLabel)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: resultsColStyle,
                    "data-testid": "IB-Hotels-List",
                    children: results === null || results === void 0 ? void 0 : results.hotels.map((hotel)=>{
                        return /*#__PURE__*/ _jsxs("button", {
                            onMouseDown: ()=>handleResultClick(hotel),
                            className: `${resultRowStyle} ${hotelRowStyle}`,
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    className: hotelBadgeStyle,
                                    alt: hotel === null || hotel === void 0 ? void 0 : hotel.suggestion,
                                    src: getHotelIcon(hotel === null || hotel === void 0 ? void 0 : hotel.brand),
                                    width: 24,
                                    height: 24
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: resultTextStyle,
                                    children: hotel === null || hotel === void 0 ? void 0 : hotel.suggestion
                                })
                            ]
                        }, hotel === null || hotel === void 0 ? void 0 : hotel.suggestion);
                    })
                })
            ]
        });
    };
    return isOpen && !isInputBlured && /*#__PURE__*/ _jsxs("div", {
        "data-testid": "Location-Results-Container",
        className: `${containerStyle} ${containerMobileStyle}`,
        style: mobile ? {
            height: `calc(100svh - ${headerHeight}px)`
        } : {},
        children: [
            !!(results === null || results === void 0 ? void 0 : (_results_places1 = results.places) === null || _results_places1 === void 0 ? void 0 : _results_places1.length) && /*#__PURE__*/ _jsx("div", {
                children: displayPlaces()
            }),
            !!(results === null || results === void 0 ? void 0 : (_results_hotels1 = results.hotels) === null || _results_hotels1 === void 0 ? void 0 : _results_hotels1.length) && /*#__PURE__*/ _jsx("div", {
                children: displayHotels()
            })
        ]
    });
};
export default LocationResults;
const containerStyle = 'absolute top-[3.75rem] flex flex-col py-2 z-50 w-[25rem] overflow-hidden rounded-md border bg-popover shadow-md';
const containerMobileStyle = 'mobile:left-0 mobile:top-[100%] mobile:border-0 mobile:border-t mobile:border-lightGrey3 mobile:w-full mobile:rounded-none mobile:overflow-scroll';
const resultsColStyle = 'flex flex-col';
const resultRowStyle = 'flex items-center px-4 text-sm leading-4 hover:bg-lightGrey5 cursor-pointer';
const resultTextStyle = 'truncate';
const hotelRowStyle = 'py-2';
const placeRowStyle = 'py-3';
const hotelsSeparatorStyle = 'text-sm leading-4 font-semibold px-4 pt-5 pb-2.5';
const hotelBadgeStyle = 'flex shrink-0 w-6 h-6 mr-4';
